import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useMemo } from 'react';
import { FlexPrivate } from '../../_primitives/flex/flex.esm.js';
import Fade from '../fade/fade.esm.js';
import Portal from '../portal/portal.esm.js';

var _excluded = ["children", "invisible", "open", "usePortal", "transitionDuration", "TransitionComponent", "bg", "backgroundColor", "zIndex", "shouldHoistTheme"];
var Backdrop = /*#__PURE__*/React.forwardRef(function Backdrop(props, ref) {
  var children = props.children,
    _props$invisible = props.invisible,
    invisible = _props$invisible === void 0 ? false : _props$invisible,
    open = props.open,
    _props$usePortal = props.usePortal,
    usePortal = _props$usePortal === void 0 ? false : _props$usePortal,
    _props$transitionDura = props.transitionDuration,
    transitionDuration = _props$transitionDura === void 0 ? 500 : _props$transitionDura,
    _props$TransitionComp = props.TransitionComponent,
    TransitionComponent = _props$TransitionComp === void 0 ? Fade : _props$TransitionComp,
    bg = props.bg,
    backgroundColor = props.backgroundColor,
    zIndex = props.zIndex,
    _props$shouldHoistThe = props.shouldHoistTheme,
    shouldHoistTheme = _props$shouldHoistThe === void 0 ? true : _props$shouldHoistThe,
    rest = _objectWithoutProperties(props, _excluded);
  var _bg = bg || backgroundColor;
  var styles = useMemo(function () {
    return _objectSpread2({
      zIndex: zIndex ? zIndex : -1,
      position: 'fixed',
      alignItems: 'center',
      justifyContent: 'center',
      right: 0,
      bottom: 0,
      top: 0,
      left: 0,
      bg: _bg ? _bg : 'opaqueBlack.3',
      WebkitTapHighlightColor: 'transparent'
    }, invisible ? {
      bg: 'transparent'
    } : {});
  }, [_bg, invisible, zIndex]);
  var content = /*#__PURE__*/React.createElement(TransitionComponent, {
    "in": open,
    timeout: transitionDuration
  }, /*#__PURE__*/React.createElement(FlexPrivate, _extends({
    __themeKey: "backdrops",
    "data-csg-test": "Backdrop",
    __css: styles,
    "aria-hidden": true,
    ref: ref
  }, rest), children));
  return usePortal ? /*#__PURE__*/React.createElement(Portal, {
    shouldHoistTheme: shouldHoistTheme
  }, content) : content;
});

export default Backdrop;
//# sourceMappingURL=backdrop.esm.js.map
